import api from '../../utils/axios';

//Constants
import { API_ROUTES } from '../../constants/apiRoutes';

export const emailTemplatesListApi = async ({ pageNumber, searchValue, sortBy, orderBy, size }) => {
  try {
    console.log('object123');
    const response = await api.get(
      `${API_ROUTES.EMAIL_TEMPLATES}?page=${pageNumber}&searchName=${searchValue}&sortBy=${sortBy}&orderBy=${orderBy}&size=${size}`
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const addEmailTemplateApi = async (data) => {
  try {
    const response = await api.post(API_ROUTES.EMAIL_TEMPLATES, data);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const editEmailTemplateApi = async (details) => {
  try {
    const response = await api.put(`${API_ROUTES.EMAIL_TEMPLATES}/${details.ID}`, details.formdata);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getEmailTemplateByIdApi = async (ID) => {
  try {
    const response = await api.get(`${API_ROUTES.EMAIL_TEMPLATES}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const deleteTemplateApi = async (ID) => {
  try {
    const response = await api.delete(`${API_ROUTES.EMAIL_TEMPLATES}/${ID}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
